/**
 * Start/end of the current calendar day in the browser's local timezone (as UTC ISO strings).
 */
export function getLocalTodayBounds() {
  const now = new Date();
  const start = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const end = new Date(start);
  end.setDate(end.getDate() + 1);
  return {
    todayStart: start.toISOString(),
    todayEnd: end.toISOString(),
  };
}
